import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreStringifiedArray } from '../../ParseHelper';

type PlayerStateKey = 'fields';
type PlayerDataKeys = 'fields';
export default class Fields implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData.fields !== JSON.stringify(playerStateData.fields.map(toLowerCase))
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return restoreStringifiedArray<string>(playerEndpointData.fields, []).map(toLowerCase);
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            fields: JSON.stringify(playerStateData.fields.map(toLowerCase)),
        };
    }
}

function toLowerCase(value:string):string {
    return value.toLowerCase();
}
